import { render } from "./UrologyPage.vue?vue&type=template&id=3ba3e03c"
import script from "./UrologyPage.vue?vue&type=script&lang=js"
export * from "./UrologyPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__